import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from '../../app/rootReducer'
import {fetchAllProvinces} from '../../app/thunk'
import {RequestStatus} from '../../shared/variables'

export const provinceSlice = createSlice({
    name: 'provinces',
    initialState: {
        allProvinces: [],
        status: RequestStatus.IDLE,
    },
    reducers: {
        setProvinces(state: RootState, action: PayloadAction<string[]>): void {
            state.allProvinces = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllProvinces.pending, (state: RootState) => {
                state.status = RequestStatus.LOADING
            })
            .addCase(
                fetchAllProvinces.fulfilled,
                (state: RootState, action) => {
                    state.allProvinces = action.payload
                    state.status = RequestStatus.SUCCEEDED
                }
            )
            .addCase(fetchAllProvinces.rejected, (state: RootState) => {
                state.status = RequestStatus.FAILED
            })
    },
})

export const {setProvinces} = provinceSlice.actions

export default provinceSlice.reducer
